// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Grpq","topBottomGutter":"Layout_topBottomGutter__38n2x"};